import { getSensorsLatestData } from '@Actions';
import { useIsFeatureEnabled } from '@innovyze/stylovyze';
import { getValue } from '@Selectors';
import { FLAGS, STATUS_ENUM } from '@Types';
import { SensorsLatestDataRequest } from '@Types/edgeAnalytics.types';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const useSensorsLatestUptimeData = () => {
	const isLastReadDateTimeEnabled = !!useIsFeatureEnabled(
		FLAGS.ENABLE_LAST_READ_DATE_TIME_SENSOR_CONFIGURATION,
	);
	const {
		configurations: { list },
	} = useSelector(getValue);
	const { sensorsLatestUptimeData } = useSelector(getValue).sensors;
	const dispatch = useDispatch();

	useEffect(() => {
		if (list.length > 0 && isLastReadDateTimeEnabled) {
			const sensors = list.map(configuration => ({
				sensorId: configuration.sensorId,
				collectionInterval: configuration.collectionInterval,
				sensorType: configuration.sensorType,
			}));
			fetchSensorsLatesUptimeData(sensors);
		}
	}, [JSON.stringify(list)]);

	const fetchSensorsLatesUptimeData = useCallback(
		(sensors: SensorsLatestDataRequest[]) => {
			dispatch(getSensorsLatestData(sensors));
		},
		[],
	);

	return {
		isLatestUptimeDataLoading:
			sensorsLatestUptimeData.status == STATUS_ENUM.PENDING,
		sensorsLatestUptimeData: sensorsLatestUptimeData.sensorsMap,
	};
};
